<template>
  <RenderContent />
</template>

<script setup lang="ts">
import { computed, provide, useSlots, type VNode, h } from 'vue'
import type { Block } from '@contentful/rich-text-types'

const props = defineProps<{
  node: Block
  [key: string]: unknown
}>()

const slots = useSlots()

// Check if this paragraph contains only a single empty text node (standalone break)
const isOnlyBreak = computed(() => {
  return (
    props.node.content?.length === 1 &&
    props.node.content[0]?.nodeType === 'text' &&
    props.node.content[0]?.value === ''
  )
})

// Provide context to child text nodes about whether this is a standalone break
provide('isStandaloneBreak', isOnlyBreak)

const RenderContent = () => {
  const defaultSlot = slots.default?.() as VNode[] | undefined

  if (!defaultSlot || defaultSlot.length === 0) {
    return null
  }

  if (isOnlyBreak.value) {
    return defaultSlot
  } else {
    return h('p', defaultSlot)
  }
}

defineOptions({
  name: 'CMSParagraphNode',
})
</script>
